angular.module('SpidApp')

.filter('ordersInventoriesByType',['_', function (_) {
    return function (inventoriesArray, filterArray) {
    	return _.chain(inventoriesArray).filter(function(inventory) {
    		 return _.find(filterArray, function(filter) {
     	    	return filter.checked  && filter.id === inventory.type;
 	    	})
    	}).value();
    }
}])

.filter('ordersInventoriesByUser',['_', function (_) {
    return function (inventoriesArray, filterArray) {
    	return _.chain(inventoriesArray).filter(function(inventory) {
    		 return _.find(filterArray, function(filter) {
     	    	return filter.checked  && filter.id === inventory.user_id;
 	    	})
    	}).value();
    }
}])

.filter('inventoryType',[function () {
    return function (type) {
    	return type === 'PRO' ?  'Produits à la vente' : 'Produits de fonctionnement';
    }
}])

